export const PATHS = {
  // Public paths
  SIGN_IN: '/signin',
  OAUTH2_REDIRECT: '/oauth2/redirect',
  OAUTH2_SIGNOUT: '/oauth2/signout',

  // Protected paths
  ACCESS_DENIED: '/access-denied',
  ASSETS: '/tenants/:tenantShortName/assets/:folderId?',
  ASSET: '/tenants/:tenantShortName/asset/:assetId',
  CRITICAL_GEOMETRY_ARTIFACT: '/tenants/:tenantShortName/asset/:assetId/critical-geometry/:artifactId',
  CHANGELOG: '/changelog',
  COMPARE: '/tenants/:tenantShortName/compare',
  DASHBOARD: '/tenants/:tenantShortName/dashboard',
  REPORT: '/tenants/:tenantShortName/report',
  REPORT_DETAIL: '/tenants/:tenantShortName/report/:id/:groupId?',
  METADATA: '/tenants/:tenantShortName/metadata',
  METADATA_BULK_UPLOAD: '/tenants/:tenantShortName/metadata-upload',
  PART_FINDER: '/tenants/:tenantShortName/part-finder',
  PART_FINDER_REPORT: '/tenants/:tenantShortName/part-finder-reports/:id',
  PART_FINDER_BATCH: '/tenants/:tenantShortName/part-finder/batches/:id',
  SEARCH: '/tenants/:tenantShortName/search',
  SUITABLE_SUBSTITUTES: '/tenants/:tenantShortName/suitable-substitutes',
  STATUS: '/tenants/:tenantShortName/status',
  TAXONOMY: '/tenants/:tenantShortName/taxonomy',
  TENANTS: '/tenants',
  USERS: '/tenants/:tenantShortName/users',
} as const;
